export const ChinaCity = [
  {
    id: "beijing",
    name: "北京",
    isCity: true,
    image: require("../assets/pictures/RoutePicture/beijingRoute.png"),
  },
  {
    id: "shanghai",
    name: "上海",
    isCity: true,
    image: require("../assets/pictures/RoutePicture/shanghaiRoute.png"),
  },
  {
    id: "guangzhou",
    name: "广州",
    isCity: true,
    image: require("../assets/pictures/RoutePicture/guangzhouRoute.png"),
  },
  {
    id: "tianjin",
    name: "天津",
    isCity: true,
    image: require("../assets/pictures/RoutePicture/tianjinRoute.png"),
  },
  {
    id: "shenzhen",
    name: "深圳",
    isCity: true,
    image: require("../assets/pictures/RoutePicture/shenzhenRoute.png"),
  },
  {
    id: "xiamen",
    name: "厦门",
    isCity: true,
    image: require("../assets/pictures/RoutePicture/xiamenRoute.png"),
  },
  {
    id: "wuxi",
    name: "无锡",
    isCity: true,
    image: require("../assets/pictures/RoutePicture/wuxiRoute.png"),
  },
  {
    id: "lanzhou",
    name: "兰州",
    isCity: true,
    image: require("../assets/pictures/RoutePicture/lanzhouRoute.png"),
  },
  {
    id: "chongqing",
    name: "重庆",
    isCity: true,
    image: require("../assets/pictures/RoutePicture/chongqingRoute.png"),
  },
  {
    id: "hebei",
    name: "河北",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/hebeiRoute.png"),
  },
  {
    id: "henan",
    name: "河南",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/henanRoute.png"),
  },
  {
    id: "shandong",
    name: "山东",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/shandongRoute.png"),
  },
  {
    id: "shanxi",
    name: "山西",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/shanxiRoute.png"),
  },
  {
    id: "zhejiang",
    name: "浙江",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/zhejiangRoute.png"),
  },
  {
    id: "hubei",
    name: "湖北",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/hubeiRoute.png"),
  },
  {
    id: "anhui",
    name: "安徽",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/anhuiRoute.png"),
  },
  {
    id: "guizhou",
    name: "贵州",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/guizhouRoute.png"),
  },
  {
    id: "yunnan",
    name: "云南",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/yunnanRoute.png"),
  },
  {
    id: "ningxia",
    name: "宁夏",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/ningxiaRoute.png"),
  },
  {
    id: "gansu",
    name: "甘肃",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/gansuRoute.png"),
  },
  {
    id: "liaoning",
    name: "辽宁",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/liaoningRoute.png"),
  },
  {
    id: "heilongjiang",
    name: "黑龙江",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/heilongjiangRoute.png"),
  },
  {
    id: "jilin",
    name: "吉林",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/jilinRoute.png"),
  },
  {
    id: "xinjiang",
    name: "新疆",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/xinjiangRoute.png"),
  },
  // {
  //   id: "neimenggu",
  //   name: "内蒙古",
  //   isCity: false,
  //   image: require("../assets/pictures/RoutePicture/neimengguRoute.png"),
  // },
  // {
  //   id: "hunan",
  //   name: "湖南",
  //   isCity: false,
  //   image: require("../assets/pictures/RoutePicture/hunanRoute.png"),
  // },
  {
    id: "commingsoon",
    name: "前面的区域以后再来探索吧！",
    isCity: false,
    image: require("../assets/pictures/RoutePicture/commingSoon.png"),
  },

  // {
  //   id: "hangzhou",
  //   name: "杭州",
  //   image: require("../assets/pictures/RoutePicture/hangzhouRoute.png"),
  // },
  // {
  //   id: "nanjing",
  //   name: "南京",
  //   image: require("../assets/pictures/RoutePicture/nanjingRoute.png"),
  // },
  // {
  //   id: "wuhan",
  //   name: "武汉",
  //   image: require("../assets/pictures/RoutePicture/wuhanRoute.png"),
  // },
  // {
  //   id: "chengdu",
  //   name: "成都",
  //   image: require("../assets/pictures/RoutePicture/chengduRoute.png"),
  // },
  // {
  //   id: "chongqing",
  //   name: "重庆",
  //   image: require("../assets/pictures/RoutePicture/chongqingRoute.png"),
  // },
  // {
  //   id: "suzhou",
  //   name: "苏州",
  //   image: require("../assets/pictures/RoutePicture/suzhouRoute.png"),
  // },
  // {
  //   id: "xi_an",
  //   name: "西安",
  //   image: require("../assets/pictures/RoutePicture/xianRoute.png"),
  // },
  // {
  //   id: "qingdao",
  //   name: "青岛",
  //   image: require("../assets/pictures/RoutePicture/qingdaoRoute.png"),
  // },
  // {
  //   id: "dalian",
  //   name: "大连",
  //   image: require("../assets/pictures/RoutePicture/dalianRoute.png"),
  // },
  // {
  //   id: "nanchang",
  //   name: "南昌",
  //   image: require("../assets/pictures/RoutePicture/nanchangRoute.png"),
  // },
];
